import * as React from 'react';
import { limuirsComponent } from 'limuirs-components';
import _ from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { avatarSizesType, dimensionsType, nodeType } from '../../../types';
import UrlManager from '../../../services/rest/UrlManager';

/**
 * Avatar for a node.
 *
 * @author Patricio Poratto, Adam Ayres
 */
const image = (crop, dimensions, node, size, text) =>
  _.has(node, `avatar.${size}_href`) ? (
    <img
      className="lia-node-avatar"
      src={UrlManager.adjustImageServerPageUrl(node.avatar[`${size}_href`], crop, dimensions)}
      alt={node.title}
    />
  ) : (
    <span
      className={classNames(
        'lia-node-avatar',
        {
          [`lia-node-avatar-${node.node_type}`]: node.node_type
        },
        'lia-node-avatar-default'
      )}
      alt={text.format('alt', { title: node.title })}
      aria-label={text.format('alt', { title: node.title })}
      role="img"
    />
  );

const NodeAvatar = ({ crop, dimensions, node, size, text, useLink }) =>
  // LIA-64730 Do not support NodeAvatar component for legacy groups
  _.get(node, 'conversation_style', null) !== 'group' &&
  (useLink ? (
    <a href={node.view_href} className="lia-node-avatar-wrapper">
      {image(crop, dimensions, node, size, text)}
    </a>
  ) : (
    <>{image(crop, dimensions, node, size, text)}</>
  ));

NodeAvatar.propTypes = {
  /** The node to display the avatar of. */
  node: nodeType.isRequired,
  /** The predefined size of image to constrain the avatar to, this will be ignored if the dimensions prop is set. */
  size: avatarSizesType,
  /** The dimensions to constrain the avatar to. */
  dimensions: dimensionsType,
  /** Whether to crop the image to the specified size */
  crop: PropTypes.bool,
  /** Whether the avatar will link to the node */
  useLink: PropTypes.bool
};

NodeAvatar.defaultProps = {
  size: 'tiny',
  dimensions: undefined,
  crop: true,
  useLink: true
};

export default limuirsComponent(module, NodeAvatar, { inert: true });
